import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap"
import Tabs from "src/components/Common/UI/Tabs/Tabs"

const LinesAndNodesHeaders = () => {
  const { t } = useTranslation();

  const tabList = [
    {name: "Διαχείριση τηλ. Γραμμών", path: "/phone-charges/phone-lines"},
    {name: "Διαχείριση Γραμμών Data", path: "/configuration/linesandnodes/lines"},    
  ]
  
  return (
    <Container fluid>
      <Row>
        <Col xs={12} className="mb-3">
          <span className="h1">{t("Διαχείριση Γραμμών")}</span>
        </Col>
        <Col xs={12}>
          <Tabs tabList={tabList} />
        </Col>
      </Row>
    </Container>
  )
}

export default LinesAndNodesHeaders;
